import type { MarketResponseDto } from "Infrastructure/Api/Api";
import { MarketEditForm } from "Market/Components/Form/MarketEditForm";
import type { FC } from "react";

type GeneralTabProps = {
	market: MarketResponseDto;
};

export const MarketGeneralTab: FC<GeneralTabProps> = ({ market }) => {
	return <MarketEditForm market={market} />;
};
